import React from 'react';

import { useRouteUtils } from 'routes';
import { Loading, Redirect } from 'components';
import { useServerData } from 'utils/react';
import { getMarketsTableData } from 'api/selectors/pages';
import { ProductSlug, VersionSlug, NetworkSlug } from 'domain/types';

import { MarketsTable } from './components';

export type MarketsProps = {
  productSlug: ProductSlug;
  versionSlug: VersionSlug;
  network: NetworkSlug;
  data: string;
};

export function Markets({ productSlug, versionSlug, network, data }: MarketsProps) {
  const dataRD = useServerData(
    () => getMarketsTableData({ productSlug, versionSlug, network }),
    [network, productSlug, versionSlug],
    data,
  );
  const { redirectTo } = useRouteUtils();

  return (
    <Loading data={dataRD}>
      {({ tableData }) =>
        tableData && tableData.length > 1 ? (
          <MarketsTable
            tableData={tableData}
            productSlug={productSlug}
            versionSlug={versionSlug}
            network={network}
          />
        ) : (
          <Redirect href={redirectTo.protocol({ productSlug, versionSlug, network }).href} />
        )
      }
    </Loading>
  );
}
